<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-08-01 17:24:03
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-01 17:24:18
 * @FilePath: /chaoyongtuan/src/views/talentCRM/emphasisTalent/emphasisTalent.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<my-talent :focus="2" sourcePage="emphasisTalent"></my-talent>
</template>
<script>
import MyTalent from '@/views/talentCRM/myTalent';
export default {
	components: {
		MyTalent,
	},
};
</script>
